import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { CustomerAppSettings, } from './CustomerAppSettings';
//import { CustomerAppSettings } from "./assets/customerappsettings";

@Injectable()
export class CustomerAppSettingsReader{

 constructor(private http: HttpClient) {
    }
  private CUSTOMER_APPSETTINGS_FILE: string = "assets/CustomerAppSettings.json";
  private CUSTOMER_APP_PROFILE_SETTINGS_FILE_PX: string = "assets/CustomerAppSettings_";
  private CUSTOMER_APP_PROFILE_SETTINGS_FILE_SX: string = ".json";
  
	
  getSettings(): Observable<CustomerAppSettings> {
    return this.http.get<CustomerAppSettings>("assets/CustomerAppSettings.json").pipe(
      catchError((err) => {
        console.warn("Could not load CustomerAppSettings.json, using default settings", err);
        return of<CustomerAppSettings>(new CustomerAppSettings());
      })
    );
  }

  getProfileSettings(branch: string): Observable<CustomerAppSettings> {
    return this.http.get<CustomerAppSettings>("assets/CustomerAppSettings_" + branch + ".json").pipe(
      catchError((err) => {
        console.warn("Could not load profile settings for branch " + branch + ", using default settings", err);
        return of<CustomerAppSettings>(new CustomerAppSettings());
      })
    );
  }
    
  private handleErrors(error: any): Observable<CustomerAppSettings> {
  // Log the error to the console
  switch (error.status) {
    case 404:
      console.error("Can't find file: " + this.CUSTOMER_APPSETTINGS_FILE);
      break;
    default:
      console.error(error);
      break;
  }

  // Return default configuration values
    return of<CustomerAppSettings>(new CustomerAppSettings());
    }

  //getSettings(): Observable<CustomerAppSettings> {
  //  let settings = new CustomerAppSettings();
  //  return Observable.of<CustomerAppSettings>(settings);
  //}
}
